/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesRoutes {
  ACCREDITATION_UPDATE_CATEGORIES_ROUTE = '/atualizacao-credenciamento/nova-atualizacao',
  ACCREDITATION_UPDATE_ROUTE = '/atualizacao-credenciamento',
  CALL_CATEGORY_ROUTE = '/chamados/tipo-solicitacao',
  CALLS_ROUTE = '/chamados',
  DASHBOARD_DOCUMENTS_DETAILS = '/documentos/:nrSeqDocumentType',
  DASHBOARD_ROUTE = '/dashboard',
  NEW_CALL_DETAILS = '/chamados/:nrSeqCall/detalhes',
  NEW_CALL_ROUTE = '/chamados/tipo-solicitacao/:nrSeqCategory/novo',
  ROUTE_ACTION_PLAN = '/plano-acao',
  ROUTE_ACTION_PLAN_DETAILS = '/plano-acao/:nrSeqActionPlan/detalhes',
  ROUTE_ACTION_PLAN_NEW = '/plano-acao/novo',
  ROUTE_CHANGE_PW = '/meus-dados/alterar-senha',
  ROUTE_CNES = '/consulta-cnes',
  ROUTE_CNES_DETAIL = '/consulta-cnes/:nrSeqCnesSearch',
  ROUTE_CONTRACTS = '/contratos',
  ROUTE_DOCUMENTS = '/documentos',
  ROUTE_FORM_TECHNICAL_VISIT = '/formulario-visita-tecnica',
  ROUTE_INDICATOR_DETAILS = '/indicadores/:nrSeqProviderIndicator/detalhes',
  ROUTE_INDICATORS = '/indicadores',
  ROUTE_MEETING_MINUTE_CONSULTATION = '/consulta-atas',
  ROUTE_MEETING_MINUTE_DETAILS = '/consulta-atas/:nrSeqProviderMeetingMinute',
  ROUTE_MESSAGE_DETAILS = '/mensagens/:nrSeqCommunication/detalhes',
  ROUTE_MESSAGES = '/mensagens',
  ROUTE_MY_DATA = '/meus-dados',
  ROUTE_NEGOTIATION = '/historico-negociacoes',
  ROUTE_NEGOTIATION_DETAILS = '/historico-negociacoes/negociacao/:nrSeqNegotiation',
  ROUTE_PRIVACY = '/privacidade',
  ROUTE_REPORTS = '/relatorios',
  ROUTE_TASK_DETAILS = '/tarefas/:nrSequenceTask/detalhes',
  ROUTE_TASKS = '/tarefas',
  ROUTE_TECHNICAL_VISIT = '/visita-tecnica',
  ROUTE_VISIT_DETAILS = '/visita-tecnica/:nrSeqVisit',
}
export { RoutesRoutes };
